import { apiPost } from "./client";

export function postTrialMember(data) {
  return apiPost("/trialmembers/", data);
}
